import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Href, TextLeft } from "../../../../Constants/Constants";

const TextLeftDemo = () => {
  const [open, setOpen] = useState(false);

  return (
    <ButtonGroup>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="down">
        <DropdownToggle caret color="primary">
          {TextLeft}
        </DropdownToggle>
        <DropdownMenu className="dropdown-block text-start">
          <DropdownItem href={Href}>{"Hello.."}</DropdownItem>
          <DropdownItem href={Href}>{"How are you?"}</DropdownItem>
          <DropdownItem href={Href}>{"What are you doing?"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default TextLeftDemo;
